import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

(function($){

    const CCISliderSwiper = {

        init: () => {

            const interval = setInterval(() => {

                if( jQuery('.cci-slider-home').length ) {
                    clearInterval(interval);

                    // const effects = ["fade", "flip", "cube", "coverflow", "slide"];
                    const effects = ["fade", "coverflow", "slide"];
                    
                    const swiper = new Swiper('.cci-slider-home', {
                        // Optional parameters
                        // direction: 'flip',
                        loop: true,
                        // loopedSlides: 10,
                        // autoplay: {
                        //     delay: 5000
                        // },
                        autoHeight: true,
                        autoplay: {
                            delay: 5000
                        },
                        // effect: effects[Math.floor(Math.random() * effects.length)],
                        effect: 'fade',
                        speed: 2000,
                        pauseOnMouseEnter: true,
                    
                        // If we need pagination
                        pagination: {
                          el: '.swiper-pagination',
                          clickable: true
                        },
                    
                        // Navigation arrows
                        // navigation: {
                        //   nextEl: '.swiper-button-next',
                        //   prevEl: '.swiper-button-prev',
                        // },
                    
                        // And if we need scrollbar
                        // scrollbar: {
                        //   el: '.swiper-scrollbar',
                        // },
                    });

                    document.querySelector('.swiper-container').addEventListener("mouseenter", function () {
                        swiper.autoplay.stop();
                    });
                    
                      // Resume autoplay when mouse leaves
                    document.querySelector(".swiper-container").addEventListener("mouseleave", function () {
                        swiper.autoplay.start();
                    });

                }

            }, 1000);
            
        }

    }

    $(function(){

        CCISliderSwiper.init();

    });

})(jQuery);